import n from "./index98.mjs";
function f(r, t) {
  for (var a = 0; a < t.length; a++) {
    var e = t[a];
    e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(r, n(e.key), e);
  }
}
function l(r, t, a) {
  return t && f(r.prototype, t), Object.defineProperty(r, "prototype", {
    writable: !1
  }), r;
}
export {
  l as default
};
